import * as Yup from "yup";

export const extendExpiryValidation = Yup.object().shape({
    extendBy: Yup.number().required("This is required"),
})